/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrusteeUserMappingDto
 */
export interface TrusteeUserMappingDto {
    /**
     * 
     * @type {string}
     * @memberof TrusteeUserMappingDto
     */
    id?: string | null;
}

export function TrusteeUserMappingDtoFromJSON(json: any): TrusteeUserMappingDto {
    return TrusteeUserMappingDtoFromJSONTyped(json, false);
}

export function TrusteeUserMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrusteeUserMappingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function TrusteeUserMappingDtoToJSON(value?: TrusteeUserMappingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

